import { IAvailabilityDay, ICompanyAvailabilityIntervals, IEmployeeAvailabilityWeek } from 'types/availabilities';
import {
  AVAILABILITIES__UNAVAILABLE,
  AVAILABILITIES__NO_AVAILABILITIES,
  AVAILABILITIES__FULL_DAY_AVAILABLE,
  AVAILABILITIES__MORNING,
  AVAILABILITIES__AFTERNOON,
  AVAILABILITIES__EVENING,
  AVAILABILITIES__MORNING_AND_AFTERNOON,
  AVAILABILITIES__MORNING_AND_EVENING,
  AVAILABILITIES__AFTERNOON_AND_EVENING,
} from 'translations/constants';
import { IDayProps } from 'modules/contracts/types';

const getDefaultAvailabilityLabel = (day: IAvailabilityDay): string => {
  if (day.isAvailableMorning && day.isAvailableAfternoon && day.isAvailableEvening) {
    return AVAILABILITIES__FULL_DAY_AVAILABLE;
  }
  if (day.isAvailableMorning && day.isAvailableAfternoon) {
    return AVAILABILITIES__MORNING_AND_AFTERNOON;
  }
  if (day.isAvailableMorning && day.isAvailableEvening) {
    return AVAILABILITIES__MORNING_AND_EVENING;
  }
  if (day.isAvailableAfternoon && day.isAvailableEvening) {
    return AVAILABILITIES__AFTERNOON_AND_EVENING;
  }
  if (day.isAvailableMorning) return AVAILABILITIES__MORNING;
  if (day.isAvailableAfternoon) return AVAILABILITIES__AFTERNOON;
  if (day.isAvailableEvening) return AVAILABILITIES__EVENING;
  return day.isSubmitted ? AVAILABILITIES__UNAVAILABLE : AVAILABILITIES__NO_AVAILABILITIES;
};

export const getAvailabilityIntervals = (
  day: IAvailabilityDay,
  companyIntervals: ICompanyAvailabilityIntervals,
): string[] => {
  const intervals: string[] = [];

  const hasIntervals =
    companyIntervals?.morningInterval && companyIntervals?.afternoonInterval && companyIntervals?.eveningInterval;

  if (!hasIntervals) {
    intervals.push(getDefaultAvailabilityLabel(day));
    return intervals;
  }

  if (day.isAvailableMorning && !day.isAvailableAfternoon && day.isAvailableEvening) {
    intervals.push(companyIntervals.morningInterval, companyIntervals.eveningInterval);
    return intervals;
  }
  if (day.isAvailableMorning) {
    let workingInterval = companyIntervals.morningInterval.split(' ')[0];
    if (day.isAvailableEvening) {
      workingInterval = `${workingInterval} - ${companyIntervals.eveningInterval.split(' ')[2]}`;
    } else if (day.isAvailableAfternoon) {
      workingInterval = `${workingInterval} - ${companyIntervals.afternoonInterval.split(' ')[2]}`;
    } else {
      workingInterval = `${workingInterval} - ${companyIntervals.morningInterval.split(' ')[2]}`;
    }
    intervals.push(workingInterval);
    return intervals;
  }
  if (day.isAvailableAfternoon) {
    let workingInterval = companyIntervals.afternoonInterval.split(' ')[0];
    if (day.isAvailableEvening) {
      workingInterval = `${workingInterval} - ${companyIntervals.eveningInterval.split(' ')[2]}`;
    } else {
      workingInterval = `${workingInterval} - ${companyIntervals.afternoonInterval.split(' ')[2]}`;
    }
    intervals.push(workingInterval);
    return intervals;
  }
  if (day.isAvailableEvening) {
    intervals.push(companyIntervals.eveningInterval);
    return intervals;
  }
  intervals.push(day.isSubmitted ? AVAILABILITIES__UNAVAILABLE : AVAILABILITIES__NO_AVAILABILITIES);
  return intervals;
};

const getAvailabilityCountForDay = (employees: IEmployeeAvailabilityWeek[], dayIndex: number): number => {
  return employees.reduce((acc, employee) => {
    const dayAvailability = employee.days[dayIndex];
    if (
      dayAvailability.isAvailableMorning ||
      dayAvailability.isAvailableAfternoon ||
      dayAvailability.isAvailableEvening
    ) {
      return acc + 1;
    }
    return acc;
  }, 0);
};

export const getAvailabilityCountForWeek = (employees: IEmployeeAvailabilityWeek[], days: IDayProps[]): number[] => {
  const availabilityCountByDay: number[] = [];
  if (days.length > 0 && employees.length > 0) {
    days.forEach((_, index) => {
      const availableThisDayCount = getAvailabilityCountForDay(employees, index);
      availabilityCountByDay.push(availableThisDayCount);
    });
  }
  return availabilityCountByDay;
};
